import Vue from 'vue';

const bus = new Vue();

/**
 * @param {string} event
 * @param {mixed} args
 */
export function dispatch (event, ...args) {
    bus.$emit(event, ...args);
}

/**
 * @param {string} event
 * @param callback
 */
export function listen (event, callback) {
    bus.$on(event, callback);
}

/**
 * @param {string} event
 * @param callback
 */
export function unlisten (event, callback) {
    bus.$off(event, callback);
}
